document.addEventListener('DOMContentLoaded', () => {

  var medias = document.querySelectorAll('.unit01-product__media');
  var dots   = document.querySelectorAll('.unit01-dot');
  var total  = medias.length;
  var current = 0;

  function showSlide(idx) {
    if (idx < 0) idx = total - 1;
    if (idx >= total) idx = 0;
    current = idx;
    medias.forEach(function(m) { m.classList.remove('is-active'); });
    dots.forEach(function(d) { d.classList.remove('is-active'); });
    medias[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  var prevBtn = document.getElementById('MediaPrev');
  var nextBtn = document.getElementById('MediaNext');
  if (prevBtn) prevBtn.addEventListener('click', function() { showSlide(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { showSlide(current + 1); });

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { showSlide(i); });
  });

  const qtyInput = document.getElementById('QtyInput');
  const qtyMinus = document.getElementById('QtyMinus');
  const qtyPlus  = document.getElementById('QtyPlus');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10);
      if (v < 9) qtyInput.value = v + 1;
    });
  }

  const sizeLabel = document.getElementById('SelectedSize');
  document.querySelectorAll('.unit01-size').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      document.querySelectorAll('.unit01-size').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      const selectedSize = btn.dataset.size;
      if (sizeLabel) sizeLabel.textContent = selectedSize;

      // FIX: read variant ID directly from the button's data-variant-id attribute
      const variantId = btn.dataset.variantId;
      if (variantId) {
        const variantInput = document.getElementById('unit01-variant-id');
        if (variantInput) variantInput.value = variantId;
      }
    });
  });

  const tempLabels = document.getElementById('TempLabels');
  const tempBtns   = document.querySelectorAll('.unit01-temp-btn');
  const LABELS = {
    c: ['-10°C', '0°C', '10°C', '20°C', '30°C'],
    f: ['14°F', '32°F', '50°F', '68°F', '86°F']
  };

  tempBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tempBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (tempLabels) {
        const unit = btn.dataset.unit;
        const spans = tempLabels.querySelectorAll('span');
        LABELS[unit].forEach((label, i) => {
          if (spans[i]) spans[i].textContent = label;
        });
      }
    });
  });

  const addToCartBtn = document.getElementById('AddToCart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      const variantInput = document.getElementById('unit01-variant-id');
      const variantId = variantInput ? variantInput.value : null;
      const qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.href = '/cart'; })
      .catch(function(err) { console.error(err); });
    });
  }

  const buyNowBtn = document.getElementById('BuyItNow');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', () => {
      const variantInput = document.getElementById('unit01-variant-id');
      const variantId = variantInput ? variantInput.value : null;
      const qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
      if (variantId) {
        window.location.href = '/cart/' + variantId + ':' + qty;
      }
    });
  }

  var unitBtns = document.querySelectorAll('.unit01-unit-toggle');
  unitBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      unitBtns.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var unit = btn.dataset.unit;
      var table = document.getElementById('SizeTable');
      if (table) {
        var cells = table.querySelectorAll('td[data-cm]');
        cells.forEach(function(cell) {
          cell.textContent = cell.getAttribute('data-' + unit);
        });
      }
    });
  });

  const sizeChartLink  = document.querySelector('.unit01-info__size-chart-link');
  const sizeChartModal = document.getElementById('SizeChartModal');
  if (sizeChartLink && sizeChartModal) {
    const openModal = function() {
      sizeChartModal.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    const closeModal = function() {
      sizeChartModal.hidden = true;
      document.body.style.overflow = '';
    };
    sizeChartLink.addEventListener('click', openModal);
    sizeChartModal.querySelectorAll('[data-sc-close]').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !sizeChartModal.hidden) closeModal();
    });
  }

  const colorLabels = document.querySelectorAll('.unit01-colorway');
  colorLabels.forEach(label => {
    label.addEventListener('click', () => {
      colorLabels.forEach(l => l.classList.remove('is-selected'));
      label.classList.add('is-selected');
    });
  });

});
